/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import { PastSupportChatBar } from './PastSupportChatBar';
import { SUPPORT_COPY } from '../../../../constants/support';
const meta = {
    title: 'Features/AIChatWidget/PastSupportChatBar',
    component: PastSupportChatBar,
    parameters: { layout: 'padded' },
    args: {
        endedAt: '2026-10-20T15:30:00Z',
        canContinue: true,
        onContinue: () => undefined,
        onBack: () => undefined
    },
    decorators: [
        (Story) => (React.createElement("div", { style: { maxWidth: '40rem', padding: '1rem' } },
            React.createElement(Story, null)))
    ]
};
export default meta;
/** A finished chat, opened from the Support chats list: read-only until the customer continues it. */
export const Default = {};
/** Continue clicked: the call is in flight. */
export const Continuing = { args: { isWorking: true } };
/** Live chat is closed right now (outside support hours): continuing waits, and the bar says when. */
export const LiveChatClosed = {
    args: {
        canContinue: false,
        unavailableNote: SUPPORT_COPY.PAST_CHAT_UNAVAILABLE('Monday–Friday, 8am–5pm ET')
    }
};
/** The chat is still loading, so there is nothing to continue yet. */
export const Loading = { args: { canContinue: false } };
/** The organization is redirected to its own IT team: permanent, so it is not worded as "right now". */
export const OrganizationRestricted = {
    args: { canContinue: false, unavailableNote: SUPPORT_COPY.PAST_CHAT_ORG_RESTRICTED }
};
